import React from "react";
import { Key, Loader, Clock, CheckCircle, XCircle, Play, RefreshCw } from "lucide-react";

const STATUS_META = {
  created:              { label: "Created",              icon: Clock },
  awaiting_deploy_key:  { label: "Setup Required",       icon: Key },
  analyzing:           { label: "Analyzing",            icon: Loader },
  awaiting_review:     { label: "Awaiting Review",      icon: Clock },
  generating_script:   { label: "Generating Script",    icon: Loader },
  ready_to_execute:    { label: "Ready to Execute",     icon: Play },
  regenerating_script: { label: "Regenerating Script",  icon: RefreshCw },
  executing:           { label: "Executing",            icon: Loader },
  succeeded:           { label: "Succeeded",            icon: CheckCircle },
  failed:              { label: "Failed",               icon: XCircle },
};

export default function RunStatusBadge({ status }) {
  const meta = STATUS_META[status] || { label: status, icon: Clock };
  const Icon = meta.icon;

  return (
    <span className={`gl-badge ${status}`}>
      <Icon size={11} />
      {meta.label}
    </span>
  );
}
